import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IReservationEditRouteParams {
    reservationId: Guid
}

const ReservationEditRoute = new AppRoute<IReservationEditRouteParams>({
    route: "/reservation/:reservationId/edit",
    navbar: true,
    authRequired: true,
})

export default ReservationEditRoute
